import { Link } from "react-router-dom";

export const HeaderBanner = () => (
  <Link to="/pricing" data-testid="header-banner" className="block bg-[#0B0F0D]">
    <img
      src="/assets/xpressprompts-header.webp"
      alt="XpressPrompts™ — Universal Short-Command Prompt Dictionary. Talk to AI in shorthand."
      className="h-auto w-full block"
      loading="eager"
    />
  </Link>
);
